import type { MailingList, MailingListDetail } from '@gozoki/api-types'
import { useQuery } from '@tanstack/react-query'
import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchMailingLists = async (): Promise<MailingList[]> => {
  const response = await gozokiApiWithAuth.get<MailingList[]>('/mailing-lists')
  return response.data
}

export const fetchMailingList = async (key: string): Promise<MailingListDetail> => {
  const response = await gozokiApiWithAuth.get<MailingListDetail>(`/mailing-lists/${key}`)
  return response.data
}

export const MAILING_LISTS_QUERY_KEY = ['mailingLists'] as const
export const mailingListDetailQueryKey = (key: string) => ['mailingList', key] as const

export const useMailingLists = () =>
  useQuery({
    queryKey: MAILING_LISTS_QUERY_KEY,
    queryFn: fetchMailingLists,
  })

export const useMailingList = (key: string) =>
  useQuery({
    queryKey: mailingListDetailQueryKey(key),
    queryFn: () => fetchMailingList(key),
    enabled: !!key,
  })
